module.exports = __webpack_public_path__ + "img/layer1.d0a92e8c.svg";